import script from "./transfer-record.vue?vue&type=script&setup=true&lang=js"
export * from "./transfer-record.vue?vue&type=script&setup=true&lang=js"

import "./transfer-record.vue?vue&type=style&index=0&id=3bcd5a3b&rel=stylesheet%2Fscss&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3bcd5a3b"]])

export default __exports__